import { NgbDropdownConfig } from '@ng-bootstrap/ng-bootstrap';
import { MenuItemView } from './../../base-models/menu-item-view';
import { ConfigService } from './../../base-services/config.service';
import { AuthenticationService } from './../../base-services/authentication.service';
import { SideMenuService } from './../side-menu/side-menu.service';
import { BaseDataService } from './../../base-services/base-data.service';
import { Component, ChangeDetectionStrategy, ChangeDetectorRef, OnInit, Input } from "@angular/core";
import { Router } from '@angular/router';
import { QueryParameter } from '../../base-models/query-parameter';

@Component({
    selector: 'yt-side-menu-v2',
    templateUrl: './side-menu-v2.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        NgbDropdownConfig
    ]
})
export class SideMenuV2Component implements OnInit {
    constructor(
        private baseDataService: BaseDataService,
        private sideMenuService: SideMenuService,
        private router: Router,
        private authenticationService: AuthenticationService,
        private configService: ConfigService,
        private changeDetectorRef: ChangeDetectorRef,
        private ngbDropdownConfig: NgbDropdownConfig
    ){
        this.ngbDropdownConfig.placement = 'bottom-left';
        this.ngbDropdownConfig.autoClose = true;
        this.ngbDropdownConfig.container = 'body';
    }

    sideMenuCollapsed: boolean = true;
    items: MenuItemView[] = [];
    autoClose: boolean = true;
    loading: boolean = false;

    private _isAuthenticated: boolean = false;
    private _expandedIDs: number[] = [];

    @Input() IsTransparent: boolean = false;

    ngOnInit(){
        this.sideMenuService.SideMenuCollapsed
            .subscribe(value => {
                if(value){
                    this._expandedIDs = this.setExpandedIDs(this.items, this._expandedIDs);
                    if(this.items)
                        this.items.forEach(item => {
                            item.Expanded = false;
                        })
                }
                else if(this.sideMenuCollapsed){
                    this.getExpandedIDs(this.items);
                }
                this.sideMenuCollapsed = value;
                this.changeDetectorRef.markForCheck();
            })

            this.authenticationService.IsAuthenticated
                .subscribe(isAuthenticated => {
                    this._isAuthenticated = isAuthenticated;
                    if(!this._isAuthenticated){
                        this.items = [];
                        this.changeDetectorRef.markForCheck();
                    }
                })

            this.configService.SelectedOrgJed
                .subscribe(selectedOrgJed => {
                    this.items = [];
                    this._expandedIDs = [];
                    this.changeDetectorRef.markForCheck();
                    if(selectedOrgJed != null && selectedOrgJed.ID && selectedOrgJed.ID > 0) {
                        this._isAuthenticated = true;
                        this.loadRootItems();
                    }
                    else{
                        this.items = [];
                        this.changeDetectorRef.markForCheck();
                    }
                })
    }

    private loadRootItems() {
        if(this._isAuthenticated) {
            this.loading = true;
            this.changeDetectorRef.markForCheck();
            this.baseDataService.Get('menuItem', 'getRoot', [], MenuItemView)
                .subscribe(data => {
                    if(this._isAuthenticated){
                        this.items = data;
                        this.loading = false;
                        this.changeDetectorRef.markForCheck();
                    }
                })
        }
    }

    private setExpandedIDs(items: MenuItemView[], expandedIDs: number[]){
        expandedIDs = [];
        if(items){
            items.forEach((item: MenuItemView) => {
                if(item.Expanded)
                    expandedIDs.push(item.ID);
                if(item.SubMenu != null)
                    this.setExpandedIDs(item.SubMenu, expandedIDs);
            })
        }
        return expandedIDs;
    }

    private getExpandedIDs(items: MenuItemView[]){
        if(items){
            items.forEach((item: MenuItemView) => {
                if(this._expandedIDs.indexOf(item.ID) > -1)
                    item.Expanded = true;
                if(item.SubMenu != null)
                    this.getExpandedIDs(item.SubMenu);
            })
        }
    }

    ItemSelected(item: MenuItemView){
        item.Expanded = !item.Expanded;
        if(!item.Expanded)
            this._expandedIDs = this._expandedIDs.splice(this._expandedIDs.indexOf(item.ID), 1);
        else if(!item.SubMenu || item.SubMenu.length == 0){
            this.LoadChildItems(item);
        }
        this.sideMenuService.SetSideMenuCollapseWithValue(false);
    }

    LoadChildItems(item: MenuItemView){
        item.Loading = true;
        this.baseDataService.Get('menuItem', 'getByMenuID', [ new QueryParameter('menuID', item.ID) ], MenuItemView)
            .subscribe(data => {
                item.SubMenu = data;
                item.Loading = false;
                this.changeDetectorRef.markForCheck();
            })
    }

    LinkClicked(ID: number, isEnabled: boolean){
        if(!isEnabled){
            return;
        }
        
        if(this.autoClose)
            this.sideMenuService.SetSideMenuCollapseWithValue(true);

        this.baseDataService.Post('menuItem', 'saveMenuAccess', ID, null)
            .subscribe(value => {});
    }

    CollapseAll(){
        //if(this.items){
            //this.items.forEach(item => {
                //item.Expanded = false;
            //})
        //}
        this.collapseItems(this.items);
    }

    private collapseItems(items: MenuItemView[]){
        items.forEach(item => {
            item.Expanded = false;
            if(item.SubMenu != null)
                this.collapseItems(item.SubMenu);
        })
    }
}
